import { z } from 'zod';
import type { IsoDate } from './common.js';
import { displayNameSchema, type Me } from './users.js';

export const emailSchema = z
  .string()
  .trim()
  .toLowerCase()
  .max(254)
  .pipe(z.email('Email no válido'));
export const passwordSchema = z
  .string()
  .min(8, 'Mínimo 8 caracteres')
  .max(128, 'Máximo 128 caracteres');

export const registerSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
  displayName: displayNameSchema,
});
export type RegisterInput = z.infer<typeof registerSchema>;

export const loginSchema = z.object({
  email: emailSchema,
  password: z.string().min(1, 'Obligatorio').max(128),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const refreshSchema = z.object({
  refreshToken: z.string().min(1),
});
export type RefreshInput = z.infer<typeof refreshSchema>;

export const forgotPasswordSchema = z.object({ email: emailSchema });
export type ForgotPasswordInput = z.infer<typeof forgotPasswordSchema>;

export const resetPasswordSchema = z.object({
  token: z.string().min(20).max(200),
  password: passwordSchema,
});
export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;

export interface AuthTokens {
  accessToken: string;
  /** Seconds until the access token expires. */
  expiresIn: number;
  refreshToken: string;
  /** Id of this sign-in in the active sessions list. */
  sessionId: string;
}

/** A device where the user is signed in (Profile → Sesiones activas). */
export interface ActiveSession {
  id: string;
  /** Human label, e.g. «Chrome en Windows» or «App de escritorio en Linux». */
  device: string;
  kind: 'desktop' | 'mobile' | 'web';
  ip: string | null;
  createdAt: IsoDate;
  lastUsedAt: IsoDate;
  /** The session making the request. */
  current: boolean;
}

export interface AuthResponse {
  user: Me;
  tokens: AuthTokens;
}
